import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/lib/stores/authStore';
import { apiClient } from '@/lib/api';

type AdminStatus = 'checking' | 'admin' | 'denied';

export default function AdminRoute({ children }: { children: React.ReactNode }) {
  const { isLoggedIn, hasHydrated } = useAuthStore();
  const [status, setStatus] = useState<AdminStatus>('checking');

  useEffect(() => {
    if (!hasHydrated || !isLoggedIn) return;

    let cancelled = false;
    apiClient
      .getMyProfile()
      .then((profile) => {
        if (!cancelled) setStatus(profile.isAdmin ? 'admin' : 'denied');
      })
      .catch(() => {
        if (!cancelled) setStatus('denied');
      });
    return () => {
      cancelled = true;
    };
  }, [hasHydrated, isLoggedIn]);

  if (!hasHydrated) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-pulse text-muted-foreground">Loading...</div>
      </div>
    );
  }

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (status === 'checking') {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-pulse text-muted-foreground">Verifying access...</div>
      </div>
    );
  }

  if (status === 'denied') {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
